// extracted by mini-css-extract-plugin
module.exports = {"buttonMore":"MoreButton_buttonMore__3-tzU"};